import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import ShoppingBagOutlinedIcon from "@mui/icons-material/ShoppingBagOutlined";
import ModeEditOutlineOutlinedIcon from "@mui/icons-material/ModeEditOutlineOutlined";
import Tooltip from "@mui/material/Tooltip";
import SignalCellularAltOutlinedIcon from "@mui/icons-material/SignalCellularAltOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import { useHistory, Link } from "react-router-dom";
import { productData, draftId } from "../../store/action";
import { useDispatch } from "react-redux";
import CircularProgress from "@mui/material/CircularProgress";

export default function CampaignTable({
  AddtoCart,
  data,
  remainDate,
  deleteshirt,
  inProgress,
  inDraft,
  completed,
  order,
}) {
  const { t } = useTranslation();
  const history = useHistory();
  const dispatch = useDispatch();
  const [shirtsdata1, setshirtdata1] = useState("");
  const [shirtsdata2, setshirtdata2] = useState("");
  const [shirtsdata3, setshirtdata3] = useState("");
  const [shirtsdata4, setshirtdata4] = useState("");
  const [draftData, setDraftdata] = useState({});
  const [loader, setLoader] = useState(false);

  const routeDraft = () => {
    inDraft
      ? history.push({
          pathname: inDraft && "/compaigndraft",
          state: inDraft && data,
        })
      : history.push({
          pathname: `/compaigndetail/${data.id}`,
          state: data,
        });
  };
  function toDataURL(url, callback) {
    var xhr = new XMLHttpRequest();
    xhr.onload = function () {
      var reader = new FileReader();
      reader.onloadend = function () {
        callback(reader.result);
      };
      reader.readAsDataURL(xhr.response);
    };
    url += "?" + new Date().getTime();
    xhr.open("GET", url);
    xhr.responseType = "blob";
    xhr.send();
  }

  const handleRoute = (data) => {
    selShirt(data);
    setLoader(true);
    setDraftdata(data);
  };
  const selShirt = async (data) => {
    await toDataURL(data.frontImg, async function (myBase64) {
      setshirtdata1(
        myBase64.replace(
          "data:binary/octet-stream;base64,",
          "data:image/png;base64,"
        )
      );
    });
    await toDataURL(data.backImg, async function (myBase64) {
      setshirtdata2(
        myBase64.replace(
          "data:binary/octet-stream;base64,",
          "data:image/png;base64,"
        )
      );
    });
    await toDataURL(data.shirtDesignFront, async function (myBase64) {
      setshirtdata3(
        myBase64 &&
          myBase64.replace(
            "data:binary/octet-stream;base64,",
            "data:image/png;base64,"
          )
      );
    });
    await toDataURL(data.shirtDesignBack, async function (myBase64) {
      setshirtdata4(
        myBase64 &&
          myBase64.replace(
            "data:binary/octet-stream;base64,",
            "data:image/png;base64,"
          )
      );
    });
  };
  useEffect(() => {
    if ((shirtsdata1, shirtsdata2, shirtsdata3, shirtsdata4)) {
      dispatch(
        productData({
          shirt: {
            cost: draftData.realprice,
            frontImg: shirtsdata1,
            backImg: shirtsdata2,
            color: draftData.color,
            frontshirturl: draftData.frontImg,
            backshirturl: draftData.backImg,
            category: draftData.shirtCategory,
            garmentName: draftData.shirtrealName,
          },
          inProgress: true,
          target: draftData.target,
          color: draftData.shirtColor,
          brief: draftData.brief,
          day: draftData.days,
          detail: draftData.detail,
          price: draftData.sellingPrice,
          id: draftData.id,
          shirtname: draftData.shirtName,
          shirtdesign:
            shirtsdata3 && shirtsdata3 !== "data:"
              ? [{ preview: shirtsdata3 }]
              : [],
          designnimg: draftData.designShirt,
          designnimgback: draftData.designShirtBack,
          realprice: draftData.realprice,
          campaign: draftData.noOfCampaigns,
          shirtdesignback:
            shirtsdata4 && shirtsdata4 !== "data:"
              ? [{ preview: shirtsdata4 }]
              : [],
          frontDesignObj: {
            width: draftData.frontDesign.width,
            height: draftData.frontDesign.height,
            x: draftData.frontDesign.x,
            y: draftData.frontDesign.y,
          },
          backDesignObj: {
            width: draftData.backDesign.width,
            height: draftData.backDesign.height,
            x: draftData.backDesign.x,
            y: draftData.backDesign.y,
          },
          step: draftData.step,
        })
      );
      dispatch(
        draftId({
          draftProductId: draftData.id,
        })
      );
      setLoader(false);
      history.push({
        pathname:
          draftData.step === 2
            ? "/setprice"
            : draftData.step === 3
            ? "/describecampaign"
            : draftData.step === 4
            ? "/preview"
            : null,
      });
      setTimeout(() => {
        setshirtdata1("");
        setshirtdata2("");
        setshirtdata3("");
        setshirtdata4("");
      }, 3000);
    }
  }, [shirtsdata1 && shirtsdata2 && shirtsdata3 && shirtsdata4]);

  const orderdata = (data) => {
    if (inProgress || completed) {
      const quantity = [];
      data.map((item) => {
        quantity.push(Number(item.quantity));
      });
      const quantityData = quantity?.reduce((x, y) => x + y);
      return quantityData;
    }
  };
  // console.log("data==>", data);
  return (
    <>
      <tr style={{ cursor: "pointer" }}>
        <td onClick={() => routeDraft()}>
          <td>
            <img
              src={data.designShirt || data.designnimg}
              width={80}
              height={100}
              style={{ marginRight: "20px" }}
              alt="shirt img"
            />
          </td>
          <td style={{ fontWeight: "bold" }}>
            {data.shirtName || data.shirtname}
          </td>
        </td>
        <td onClick={() => routeDraft()}>
          <td>
            <small>
              {remainDate(data.createdAt, data.days) + 1 <= 0
                ? 0
                : remainDate(data.createdAt, data.days) + 1}
              {t("d")}
            </small>
          </td>
          <td>
            <small style={{ marginLeft: "5px" }}>{t("remain")}</small>
          </td>
        </td>
        <td onClick={() => routeDraft()}>
          <small>
            {(inProgress || completed) && data?.orders?.items?.length
              ? orderdata(data?.orders?.items)
              : 0}{" "}
            {t("pre-order")}
          </small>
        </td>
        <td onClick={() => routeDraft()}>
          <small>
            {(inProgress || completed) && data?.orders?.items?.length
              ? orderdata(data?.orders?.items) * data.sellingPrice
              : 0}{" "}
            €
          </small>
        </td>
        <td
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "35px",
          }}
        >
          <td
            className="cp"
            style={{
              border: "1px solid #000",
              height: "40px",
              padding: "0px 9px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "230px",
              background: "#fff",
            }}
            onClick={() => AddtoCart(data)}
          >
            <td>
              <td>
                <ShoppingBagOutlinedIcon />
              </td>
              <td>
                <small>{t("prototype")}</small>
              </td>
            </td>
          </td>
        </td>
        <td className="icons cp" style={{ textAlign: "end" }}>
          {inDraft && (
            <Tooltip title={t("edit")} arrow placement="top">
              {loader ? (
                <CircularProgress size="20px" color="inherit" />
              ) : (
                <ModeEditOutlineOutlinedIcon
                  onClick={() => handleRoute(data)}
                />
              )}
            </Tooltip>
          )}
          {inProgress && (
            <Tooltip title={t("analytics")} arrow placement="top">
              <SignalCellularAltOutlinedIcon
                onClick={() => history.push(`/compaigndetail/${data.id}`)}
              />
            </Tooltip>
          )}
          {!inProgress && (
            <Tooltip title={t("delete")} arrow placement="top">
              <DeleteOutlineOutlinedIcon onClick={() => deleteshirt(data)} />
            </Tooltip>
          )}
        </td>
      </tr>
    </>
  );
}
